import type { FieldGroupBlockConfig } from '@lighthouse/core'

export const generateFieldGroupBlock = (mainBreakPoint: string): FieldGroupBlockConfig => {
    return {
        viewFields: [],
        pointer: '',
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 'auto'
                },
                overflow: 'visible'
            }
        },
        breakPoints: []
    }
}
